import { render, staticRenderFns } from "./FormImmutableField.vue?vue&type=template&id=3cfd0488&scoped=true&"
import script from "./FormImmutableField.vue?vue&type=script&lang=js&"
export * from "./FormImmutableField.vue?vue&type=script&lang=js&"
import style0 from "./FormImmutableField.vue?vue&type=style&index=0&id=3cfd0488&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfd0488",
  null
  
)

export default component.exports